export default __webpack_public_path__ + "static/media/master_copy_icon.c1e28565.svg";